jQuery(function ($) {

    let $donationApp = $('#donation-app');

    let threeDSecure;

    if($donationApp.length){
        new Vue({
            el: "#donation-app",
            data: {
                loading: true,
                authorization: '',
                payment_types: [],
                donation_data: [],
                available_payment_methods: [],
                step: 0,
                amount: 0,
                active_preset: '',
                active_preset_score: '',
                benefitHtml: '',
                your_amount: '',
                your_amount_error: '',
                card_brand: 'Card',
                card_code_name: 'CVV/CVV',
                hostedFieldsInstance: null,
                regions: [],
                region: {},
                showRegionDropdown: false,
                showHostedFieldsValidationErrors: false,
                failedMessage: '',
                form: {

                    agree: false,
                    donation_amount: 0,
                    payment_type: '',
                    payment_method: '',
                    currency: 'EUR',
                    region_name: 'European Union',
                    region_name_short: 'EU',
                    region_name_from: 'EU',
                    region_code: 'EU',
                    receive_benefits: 0,

                    // form fieldsreceive_benefits
                    // !!! this fields not included: cc-number, cc-cvv, cc-expiration, postal-code
                    email: '',
                    phone: '',
                    address: '',
                    address2: '',

                    // update 2021-08-03 locality
                    locality: '',

                    country: '',
                    name: '',
                    lastname: '',

                    // braintree fields
                    device_data: '',

                    // carrot quest
                    //carrotquest_id: '',
                },
                errors: {},
                threeDSecure: '',
            },
            methods: {

                createCookie(name, value, days) {
                    if (days) {
                        var date = new Date();
                        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                        var expires = "; expires=" + date.toUTCString();
                    } else var expires = "";
                    document.cookie = name + "=" + value + expires + "; path=/";
                },

                readCookie(name) {
                    var nameEQ = name + "=";
                    var ca = document.cookie.split(';');
                    for (var i = 0; i < ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
                    }
                    return null;
                },

                eraseCookie(name) {
                    createCookie(name, "", -1);
                },

                /**
                 * @param preset
                 */
                setPreset(preset) {
                    this.amount = this.getPresetMinAmount(preset);
                    this.active_preset = preset;
                    this.your_amount = '';
                },

                showBenefits() {
                    if (this.form.payment_type === 'monthly') return true;
                    if (this.form.payment_type === 'yearly') return true;
                    return !!parseInt(this.form.receive_benefits);
                },

                loadBenefitsHtml() {
                    //let preset = this.findPresetByAmount(this.amount);
                    let lang = document.documentElement.getAttribute('lang');
                    let rank = this.getActivePresetRule('rank', '', true);
                    axios.get('/wp-admin/admin-ajax.php?lang=' + lang + '&action=benefit&rank=' + rank).then(response => {
                        if (response.data.success) {
                            this.benefitHtml = response.data.html;
                        } else {
                            this.benefitHtml = '';
                            if (response.data.message) {
                                console.warn(response.data.message);
                            }
                        }
                    }).catch(error => {
                        this.benefitHtml = '';
                    });
                },

                number_format(number, decimals, dec_point, thousands_sep) {
                    var n = !isFinite(+number) ? 0 : +number,
                        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                        toFixedFix = function (n, prec) {
                            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
                            var k = Math.pow(10, prec);
                            return Math.round(n * k) / k;
                        },
                        s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
                    if (s[0].length > 3) {
                        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
                    }
                    if ((s[1] || '').length < prec) {
                        s[1] = s[1] || '';
                        s[1] += new Array(prec - s[1].length + 1).join('0');
                    }
                    return s.join(dec);
                },

                /**
                 * @param value
                 * @returns {string}
                 */
                getCurrencyHtml(value) {
                    if (this.form.currency === 'EUR') {
                        return '€' + this.number_format(value, 0, '', '.');
                    }
                    if (this.form.currency === 'USD') {
                        return '$' + this.number_format(value, 0, '', ',');
                    }
                    if (this.form.currency === 'CHF') {
                        return this.number_format(value, 0, '', '.') + ' CHF';
                    }
                    if (this.form.currency === 'RUB') {
                        return this.number_format(value, 0, '', ' ') + ' ₽';
                    }
                },

                supportedAmountText() {
                    if (this.form.currency === 'EUR') {
                        return 'Euro ' + this.form.donation_amount;
                    }
                    if (this.form.currency === 'USD') {
                        return 'USD ' + this.form.donation_amount;
                    }
                    if (this.form.currency === 'CHF') {
                        return 'CHF ' + this.form.donation_amount;
                    }
                    if (this.form.currency === 'RUB') {
                        return this.form.donation_amount + ' руб.';
                    }
                },

                onPaymentTypeChange() {
                    this.amount = this.getPresetMinAmount(this.active_preset_score);
                    this.active_preset = this.findPresetByAmount(this.amount);
                    this.form.donation_amount = this.getPresetMinAmount(this.active_preset);
                    this.your_amount = this.getPresetMinAmount(this.active_preset);
                    this.active_preset_score = this.findPresetByAmount(this.form.donation_amount);
                },

                setRegion(region) {
                    let old_region = this.region;
                    let old_currency = this.form.currency;
                    if(old_region === region) return;

                    let currency_changed = false;
                    if(old_currency !== this.regions[region].currency){
                        currency_changed = true;
                    }

                    this.region = region;
                    if(currency_changed){
                        this.form.currency = this.regions[region].currency;
                        this.active_preset_score = this.findPresetByAmount(this.amount);
                    }

                    this.form.region_name = this.regions[region].text;
                    this.form.region_name_short = this.regions[region].name_short;
                    this.form.region_name_from = this.regions[region].name_from;
                    this.form.region_code = region;

                    //if(this.getActivePresetRule('min', '-1', false) === '-1'){
                    if(currency_changed) {
                        this.active_preset = this.findFirstPresetWithCurrency(this.form.currency);
                        this.form.donation_amount = this.getPresetMinAmount(this.active_preset);
                        this.your_amount = this.getPresetMinAmount(this.active_preset);
                        this.active_preset_score = this.findPresetByAmount(this.form.donation_amount);
                    }
                    //}
                    //this.amount = this.getPresetMinAmount(this.active_preset);
                },

                checkPresetAvailable(preset) {
                    if (typeof this.donation_data[this.form.payment_type][preset] === 'undefined') return false;
                    if (typeof this.donation_data[this.form.payment_type][preset]['rules'][this.form.currency] === 'undefined') return false;
                    return true;
                },

                checkPresetVisible(preset) {
                    if (!this.checkPresetAvailable(preset)) return false;
                    return this.donation_data[this.form.payment_type][preset]['rules'][this.form.currency]['caption'] !== '';
                },

                getPresetMinAmount(preset) {
                    let currencyRules = this.donation_data[this.form.payment_type][preset]['rules'][this.form.currency];
                    return currencyRules.min;
                },

                findPresetByAmount(amount) {
                    let result_preset = 0;
                    let result_preset_left = 0;
                    let result_preset_right = 0;
                    amount = parseInt(amount);
                    Object.entries(this.donation_data[this.form.payment_type]).forEach(([preset, presetData]) => {
                        if (typeof presetData['rules'][this.form.currency] !== 'undefined') {
                            let currencyRules = presetData['rules'][this.form.currency];
                            if (amount >= currencyRules.min && amount <= currencyRules.max) {
                                result_preset = preset;
                            }
                            if (amount < parseInt(currencyRules.min)) {
                                result_preset_left = preset;
                            }
                            if (amount > parseInt(currencyRules.max)) {
                                result_preset_right = preset;
                            }
                        }
                    });
                    return result_preset || result_preset_right || result_preset_left;
                },

                findFirstPresetWithCurrency(currency) {
                    let result_preset = -1;

                    Object.entries(this.donation_data[this.form.payment_type]).forEach(([preset, presetData]) => {
                        if (result_preset === -1) {
                            if (typeof presetData['rules'][currency] !== 'undefined' && presetData['rules'][currency]['caption']) {
                                result_preset = preset;
                            }
                        }
                    });

                    return result_preset;
                },

                getActivePresetRule(rule, def, useScoredPreset) {
                    if (typeof def === 'undefined') def = '';
                    if (typeof useScoredPreset === 'undefined') useScoredPreset = false;

                    let preset;
                    if (!useScoredPreset) {
                        preset = this.donation_data[this.form.payment_type][this.active_preset];
                    } else {
                        preset = this.donation_data[this.form.payment_type][this.active_preset_score];
                    }

                    if (typeof preset === 'undefined') {
                        return def;
                    }

                    let rules = preset['rules'][this.form.currency]
                    if (typeof rules === 'undefined') {
                        return def;
                    }
                    let val = rules[rule];
                    if (typeof val === 'undefined') return def;
                    return val;
                },

                getPresetBtnCaption(preset) {
                    let presetRules = this.donation_data[this.form.payment_type][preset]['rules'][this.form.currency];
                    return presetRules['caption'] || presetRules['min'] || '';
                },

                onThreeDSecureModalClose() {
                    this.loading = false;
                    threeDSecure.cancelVerifyCard();
                },

                submitDonation() {

                    this.loading = true;
                    this.failedMessage = '';

                    if (this.hostedFieldsInstance === null) return;

                    let state = this.hostedFieldsInstance.getState();

                    // Сброс ошибок
                    this.errors = {};
                    this.showHostedFieldsValidationErrors = true;

                    let data = this.form;

                    let lang = 'en';
                    if(typeof ma_ajax.lang !== 'undefined'){
                        lang = ma_ajax.lang;
                    }

                    data.validate_only = true;

                    // Loop through the Hosted Fields and check
                    // for validity, apply the is-invalid class
                    // to the field container if invalid
                    Object.keys(state.fields).forEach((field) => {
                        if (!state.fields[field].isValid) {
                            this.errors[field] = state.fields[field];
                        }
                    });

                    // perform validations on the non-Hosted Fields inputs
                    axios.post('/wp-admin/admin-ajax.php?action=donate&lang=' + lang, data).then((response) => {

                        if (this.errors.length) {
                            // skip tokenization request if any fields are invalid
                            this.loading = false;
                            return;
                        }

                        if(ma_ajax && ma_ajax.is_admin){
                            console.log(data);

                            // data.name
                            // data.lastname
                            // data.phone (may be empty)
                            // data.email
                        }

                        /*if(carrotquest){

                            let carrotquest_api_key = ma_ajax.carrotquest_api_key;
                            if(!carrotquest_api_key){
                                console.warn('carrotquest api key not found in ma_ajax.');
                                return;
                            }

                            carrotquest.connect(carrotquest_api_key);

                            let identity_bag = [];

                            if(data.name && data.lastname){
                                identity_bag.push({
                                    op: 'update_or_create',
                                    key: '$name',
                                    value: data.name + ' ' + data.lastname
                                });
                            }

                            if(data.email) {
                                identity_bag.push({
                                    op: 'update_or_create',
                                    key: '$email',
                                    value: data.email
                                });
                            }

                            if(data.phone){
                                identity_bag.push({
                                    op: 'update_or_create',
                                    key: '$phone',
                                    value: data.phone
                                });
                            }

                            carrotquest.identify(identity_bag);

                        }*/

                        data.validate_only = false;

                        // Оплата по карте
                        if(this.form.payment_method === 'pay_by_card'){
                            this.hostedFieldsInstance.tokenize({
                                // include the cardholderName in the tokenization
                                // request
                                cardholderName: $('#cc-name').val()
                            }, (err, payload) => {

                                if (err) {

                                    this.loading = false;

                                    if(ma_ajax && ma_ajax.is_admin) {
                                        console.error('hostedFieldsInstance tokenize error');
                                        console.error(err);
                                    }

                                    return;
                                }

                                // This is where you would submit payload.nonce to your server

                                // you can either send the form values with the payment
                                // method nonce via an ajax request to your server,
                                // or add the payment method nonce to a hidden inpiut
                                // on your form and submit the form programatically

                                let billingAddress = {
                                    givenName: this.form.name,
                                    surname: this.form.lastname,
                                    streetAddress: this.form.address,
                                    countryCodeAlpha2: this.form.country
                                };

                                if(this.form.address2.length){
                                    billingAddress.extendedAddress = this.form.address2;
                                }

                                // update 2021-08-03 locality
                                if(this.form.locality.length){
                                    billingAddress.locality = this.form.locality;
                                }

                                if(this.form.phone.length){
                                    billingAddress.phoneNumber = this.form.phone;
                                }

                                let threeDSecureParameters = {
                                    amount: this.form.donation_amount,
                                    nonce: payload.nonce,
                                    bin: payload.details.bin,
                                    email: this.form.email,
                                    billdingAddress: billingAddress,
                                    onLookupComplete: function (data, next) {
                                        // use `data` here, then call `next()`

                                        if(ma_ajax && ma_ajax.is_admin) {
                                            console.log('onLookupComplete data', data);
                                            console.log('onLookupComplete next', next);
                                        }

                                        next();
                                    },
                                    /*addFrame: (err, iframe) => {
                                        // Set up your UI and add the iframe.
                                        //this.$bvModal.show('modal-threeD-secure');

                                        this.$refs['threeD-secure-modal'].show();

                                        setTimeout(() => {
                                            let my3DSContainer = document.getElementById('modal-threeD-secure-content');
                                            my3DSContainer.appendChild(iframe);
                                        }, 500);
                                    },
                                    removeFrame: () => {
                                        // Remove UI that you added in addFrame.
                                        //this.$bvModal.hide('modal-threeD-secure');
                                        this.$refs['threeD-secure-modal'].hide();
                                    }*/
                                }

                                if(ma_ajax && ma_ajax.is_admin){
                                    console.log('threeDSecureParameters', threeDSecureParameters);
                                }

                                threeDSecure.verifyCard(threeDSecureParameters, (err, response) => {

                                    if (err) {

                                        this.loading = false;

                                        if(ma_ajax && ma_ajax.is_admin){
                                            console.log('threeDSecure.verifyCard err', err);
                                        }

                                        return;
                                    }

                                    // Send response.nonce to use in your transaction
                                    data.nonce = response.nonce;

                                    if(ma_ajax && ma_ajax.is_admin) {
                                        console.log('nonce', data.nonce);
                                    }

                                    axios.post('/wp-admin/admin-ajax.php?action=donate&lang=' + lang, data).then((response) => {

                                        this.loading = false;

                                        if (!response.data.success) {
                                            // something went wrong

                                            console.error('donate failed');
                                            console.error(response.data.message);

                                            this.failedMessage = response.data.message;
                                        }


                                        if (response.data.success) {

                                            if(ma_ajax && ma_ajax.is_admin) {
                                                console.error('donate success');
                                            }

                                            this.step = 3;

                                            this.animateToThankYou();

                                        }

                                    }).catch((error) => {
                                        this.loading = false;

                                        if(ma_ajax && ma_ajax.is_admin) {
                                            console.error('donate exception', error);
                                        }

                                        this.errors = error.response.data.errors;

                                    });

                                });

                            });
                        }

                        // Оплата чеком или переводом
                        if(this.form.payment_method === 'pay_by_check_or_transfer'){
                            axios.post('/wp-admin/admin-ajax.php?action=donate&lang=' + lang, data).then((response) => {
                                this.loading = false;
                                if (!response.data.success) {
                                    // something went wrong
                                    this.failedMessage = response.data.message;
                                }
                                if (response.data.success) {
                                    this.step = 3;

                                    this.animateToThankYou();

                                }
                            }).catch((error) => {
                                console.error(error);
                                this.loading = false;
                                this.errors = error.response.data.errors;
                            });
                        }

                    }).catch((error) => {
                        console.error(error);
                        this.loading = false;
                        Object.entries(error.response.data.errors).forEach((error) => {
                            this.errors[error[0]] = error[1];
                        });
                    });
                },

                /**
                 * @param clientInstance
                 */
                createDataCollector(clientInstance) {
                    braintree.dataCollector.create({
                        client: clientInstance,
                        kount: true
                    }, (err, dataCollectorInstance) => {
                        if (err) {
                            // Handle error in creation of data collector
                            return;
                        }
                        // At this point, you should access the dataCollectorInstance.deviceData value and provide it
                        // to your server, e.g. by injecting it into your form as a hidden input.
                        //var deviceData = dataCollectorInstance.deviceData;

                        this.form.device_data = dataCollectorInstance.deviceData;
                    });
                },

                /**
                 * @param clientInstance
                 */
                createHostedFields(clientInstance) {

                    this.loading = true;

                    braintree.hostedFields.create({
                        client: clientInstance,
                        styles: {
                            input: {
                                // change input styles to match
                                // bootstrap styles
                                'font-size': '1.25rem',
                                color: '#495057'
                            }
                        },
                        fields: {
                            number: {
                                selector: '#cc-number',
                                placeholder: '4111 1111 1111 1111'
                            },
                            cvv: {
                                selector: '#cc-cvv',
                                placeholder: '123'
                            },
                            expirationDate: {
                                selector: '#cc-expiration',
                                placeholder: 'MM / YY'
                            },
                            postalCode: {
                                selector: '#postal-code',
                                placeholder: '11111'
                            }
                        }
                    }, (err, hostedFieldsInstance) => {

                        this.loading = false;

                        if (err) {
                            console.error(err);
                            return;
                        }

                        this.hostedFieldsInstance = hostedFieldsInstance;

                        hostedFieldsInstance.on('validityChange', (event) => {
                            // Remove any previously applied error or warning classes
                            this.errors = {};

                            if (this.showHostedFieldsValidationErrors) {
                                Object.keys(event.fields).forEach((field) => {
                                    if (!event.fields[field].isValid) {
                                        this.errors[field] = event.fields[field];
                                    }
                                });
                            }

                        });

                        hostedFieldsInstance.on('cardTypeChange', (event) => {
                            if (event.cards.length === 1) {
                                var card = event.cards[0];
                                this.card_brand = card.niceType; // card.code.name
                                this.card_code_name = card.code.name;
                            } else {
                                // reset to defaults
                                this.card_brand = 'Card';
                                this.card_code_name = 'CVV/CVV';
                            }
                        });
                    });
                },

                /**
                 * PayPal checkout
                 */
                /*createPaypalCheckout(clientInstance) {

                    this.loading = true;

                    // Create a PayPal Checkout component.
                    braintree.paypalCheckout.create({
                        client: clientInstance
                    }, (paypalCheckoutErr, paypalCheckoutInstance) => {

                        // Stop if there was a problem creating PayPal Checkout.
                        // This could happen if there was a network error or if it's incorrectly
                        // configured.
                        if (paypalCheckoutErr) {
                            console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                            return;
                        }

                        // Load the PayPal JS SDK (see Load the PayPal JS SDK section)
                        paypalCheckoutInstance.loadPayPalSDK({
                            currency: this.form.currency,
                            intent: 'capture'
                        }, () => {
                            paypal.Buttons({
                                fundingSource: paypal.FUNDING.PAYPAL,

                                createOrder: () => {
                                    return paypalCheckoutInstance.createPayment({
                                        flow: 'checkout', // Required
                                        amount: this.form.donation_amount, // Required
                                        currency: this.form.currency, // Required, must match the currency passed in with loadPayPalSDK

                                        intent: 'capture', // Must match the intent passed in with loadPayPalSDK

                                        enableShippingAddress: false,
                                        //shippingAddressEditable: true,
                                        //shippingAddressOverride: {
                                        //    recipientName: 'Scruff McGruff',
                                        //    line1: '1234 Main St.',
                                        //    line2: 'Unit 1',
                                        //    city: 'Chicago',
                                        //    countryCode: 'US',
                                        //    postalCode: '60652',
                                       //     state: 'IL',
                                        //    phone: '123.456.7890'
                                        //}
                                    });
                                },

                                onApprove: (data, actions) => {
                                    return paypalCheckoutInstance.tokenizePayment(data, (err, payload) => {
                                        // Submit `payload.nonce` to your server
                                        // todo: ...

                                        console.log('paypal payload', payload);

                                    });
                                },

                                onCancel: (data) => {
                                    console.log('PayPal payment cancelled', JSON.stringify(data, 0, 2));
                                },

                                onError: (err) => {
                                    console.error('PayPal error', err);
                                }
                            }).render('#paypal-button').then(() => {
                                // The PayPal button will be rendered in an html element with the ID
                                // `paypal-button`. This function will be called when the PayPal button
                                // is set up and ready to be used

                                this.loading = false;
                            });

                        });
                    });
                },*/ // PayPal checkout

                animateToThankYou() {
                    setTimeout(() => {
                        let $thankYou = $('#thank-you');
                        if($thankYou.length){
                            $('html, body').animate({
                                'scrollTop': $thankYou.offset().top - window.innerHeight / 2 + $thankYou.innerHeight() / 2
                            }, 500);
                        }
                    }, 250);
                }

            },
            watch: {
                step: function (val) {
                    if (val === 2) {

                        if (!this.your_amount && this.getActivePresetRule('manual')) {
                            this.your_amount_error = 'The amount field is required.';
                            this.step = 1;
                            return;
                        }

                        this.loading = true;

                        if (['USD', 'EUR', 'CHF', 'RUB'].indexOf(this.form.currency) > -1) {
                            this.authorization = $donationApp.data('braintree-authorization-' + this.form.currency.toLowerCase());

                            if (typeof braintree.client === 'undefined') {
                                console.error('Не найден модуль braintree.client');
                            }

                            braintree.client.create({
                                authorization: this.authorization
                            }, (err, clientInstance) => {

                                if (err) {
                                    console.error(err);
                                    this.loading = false;
                                    return;
                                }

                                if (typeof braintree.threeDSecure === 'undefined') {
                                    console.error('Не найден модуль braintree.threeDSecure');
                                }

                                braintree.threeDSecure.create({
                                    version: 2, // Will use 3DS 2 whenever possible
                                    client: clientInstance
                                }, function (threeDSecureErr, threeDSecureInstance) {
                                    if (threeDSecureErr) {
                                        // Handle error in 3D Secure component creation
                                        console.error('threeDSecureErr', threeDSecureErr);
                                        return;
                                    }
                                    threeDSecure = threeDSecureInstance;
                                });

                                this.createDataCollector(clientInstance);
                                this.createHostedFields(clientInstance);
                                //this.createPaypalCheckout(clientInstance);
                            });
                        }
                        else {
                            console.error('Unknown currency ' + this.form.currency);
                        }

                        this.available_payment_methods = [];
                        this.available_payment_methods.push('pay_by_card');
                        this.form.payment_method = 'pay_by_card';

                        if (['USD', 'EUR', 'CHF'].indexOf(this.form.currency) > -1) {
                            if (this.amount >= 1000) {
                                this.available_payment_methods.push('pay_by_check_or_transfer');
                            }
                        }
                        if (['RUB'].indexOf(this.form.currency) > -1) {
                            if (this.amount >= 100000) {
                                this.available_payment_methods.push('pay_by_check_or_transfer');
                            }
                        }

                    }
                },
                amount: function (val) {
                    this.form.donation_amount = this.your_amount || this.amount;
                    this.active_preset_score = this.findPresetByAmount(this.form.donation_amount);
                    this.loadBenefitsHtml();
                },
                your_amount: function (val) {
                    this.form.donation_amount = this.your_amount || this.amount;
                    this.active_preset_score = this.findPresetByAmount(this.form.donation_amount);
                    this.loadBenefitsHtml();
                },
                region: function (val, old_val) {
                    if (typeof old_val === 'string') {
                        console.log('region manually changed to:', val);
                        let data = {
                            country_code: val
                        }
                        this.createCookie('region_manual', val);
                    }
                    if (val === 'OTHER') this.showRegionDropdown = true;
                }
            },
            mounted() {
                let donation_datum = JSON.parse(atob($donationApp.data('donation-data')));

                Object.entries(donation_datum).forEach(([p_type, payment_data]) => {
                    if (this.form.payment_type === '') {
                        this.form.payment_type = p_type;
                    }
                    this.payment_types.push(p_type);
                });

                this.donation_data = donation_datum;
                this.form.currency = $donationApp.data('currency').toUpperCase();

                let default_preset = this.findFirstPresetWithCurrency(this.form.currency);
                let default_preset_preset_currencyRules = this.donation_data[this.form.payment_type][default_preset]['rules'][this.form.currency];
                if (typeof default_preset_preset_currencyRules !== 'undefined') {
                    this.amount = default_preset_preset_currencyRules.min;
                }
                this.active_preset = this.findPresetByAmount(this.amount);
                this.active_preset_score = this.findPresetByAmount(this.amount);

                this.regions = JSON.parse(atob($donationApp.data('region-options')));
                this.setRegion($donationApp.data('region-default'));

                let region_manual = this.readCookie('region_manual');
                if(region_manual){
                    this.setRegion(region_manual);
                }

                this.step = 1;

                /*let carrotquest_api_key = ma_ajax.carrotquest_api_key;
                if(!carrotquest_api_key){
                    console.warn('carrotquest api key not found in ma_ajax.');
                    return;
                }

                if(!carrotquest){
                    console.warn('carrotquest not found.');
                    return;
                }

                carrotquest.connect(carrotquest_api_key);

                if(carrotquest.data && carrotquest.data.user.id){
                    this.form.carrotquest_id = carrotquest.data.user.id;
                }
                else {
                    this.form.carrotquest_id = '';
                }*/

                this.loading = false;
            }
        });
    }

});

